/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Location_PrivacyInputs */

const cs_form_location_privacy = /** @type {(inputs: Form_Location_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soukromí lokace`)
};

const en_form_location_privacy = /** @type {(inputs: Form_Location_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location privacy`)
};

/**
* | output |
* | --- |
* | "Location privacy" |
*
* @param {Form_Location_PrivacyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_location_privacy = /** @type {((inputs?: Form_Location_PrivacyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Location_PrivacyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_location_privacy(inputs)
	return cs_form_location_privacy(inputs)
});